import { Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <Typography className="Typography footer-text">
        Copyright &copy; Travel Booking App
      </Typography>
    </footer>
  );
};

export default Footer;
